export type PasswordUpdateError =
  | "password_requirements"
  | "password_same"
  | "recovery_session_missing"
  | "password_update_failed";

export type PasswordResetError = "email_rate_limit" | "password_reset_failed";

export const meetsPasswordRequirements = (password: string) =>
  password.length >= 12
  && /[a-z]/.test(password)
  && /[A-Z]/.test(password)
  && /[0-9]/.test(password)
  && /[^A-Za-z0-9]/.test(password);

export const mapPasswordUpdateError = (error: { code?: string | undefined; message?: string | undefined } | null): PasswordUpdateError | null => {
  if (!error) return null;
  const code = error.code?.toLowerCase() ?? "";
  const message = error.message?.toLowerCase() ?? "";
  if (code === "weak_password" || message.includes("password should contain") || message.includes("password should be at least")) {
    return "password_requirements";
  }
  if (code === "same_password" || message.includes("different from the old password") || message.includes("same password")) {
    return "password_same";
  }
  return "password_update_failed";
};

export const mapPasswordResetError = (error: { code?: string | undefined; message?: string | undefined; status?: number | undefined } | null): PasswordResetError | null => {
  if (!error) return null;
  const code = error.code?.toLowerCase() ?? "";
  const message = error.message?.toLowerCase() ?? "";
  if (error.status === 429 || code === "over_email_send_rate_limit" || message.includes("email rate limit")) {
    return "email_rate_limit";
  }
  return "password_reset_failed";
};
